import { Box, useTheme, type SxProps, type Theme } from '@mui/material';
import { type ReactNode } from 'react';
import { useContentWrapperPadding } from './ContentWrapper.hooks';
import type { IStylesOverrides } from '../common-types';

export type ContentWrapperProps = {
  styleOverrides?: IStylesOverrides;
  defaultPadding: number;
  alignCenter?: boolean;
  children: ReactNode;
  sx?: SxProps<Theme>;
};

/**
 * ContentWrapper component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 */
export const ContentWrapper = ({
  children,
  sx,
  styleOverrides,
  defaultPadding,
  ...props
}: ContentWrapperProps) => {
  const theme = useTheme();

  const containerPadding = useContentWrapperPadding({
    defaultPadding,
    styleOverrides: styleOverrides ?? {},
  });

  return (
    <Box
      sx={{
        maxWidth: theme.breakpoints.values.lg,
        margin: 'auto',
        padding: theme.spacing(2),
        paddingTop: containerPadding('top'),
        paddingBottom: containerPadding('bottom'),
        ...sx,
      }}
      data-testid="content-wrapper"
      {...props}
    >
      {children}
    </Box>
  );
};
